"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.instantDeReference = exports.estDisponibleA = exports.eligiblePromotions = void 0;
var eligibility_1 = require("./eligibility");
Object.defineProperty(exports, "eligiblePromotions", { enumerable: true, get: function () { return eligibility_1.eligiblePromotions; } });
Object.defineProperty(exports, "estDisponibleA", { enumerable: true, get: function () { return eligibility_1.estDisponibleA; } });
Object.defineProperty(exports, "instantDeReference", { enumerable: true, get: function () { return eligibility_1.instantDeReference; } });
